import BaseCtrl from 'edge/platform/base/BaseCtrl';

var fn = function fn($scope, LocaleService) {
    var ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.getLocation = function (locationNumber) {
            return $scope.cpPolicyExtension.locations.find(function (location) {
                return location.number === locationNumber;
            });
        };

        $scope.localeInfo = LocaleService.getLocaleInfo;

        $scope.estimateReceived = function () {
            return $scope.incident.estimateReceived.value && $scope.incident.estimateReceived.value.code === 'Yes';
        };

        $scope.$watch('estimateReceived()', function (newValue, oldValue) {
            // switching from on to off
            if (!newValue && oldValue) {
                if (!$scope.incident.estRepairCost.aspects.valid) {
                    $scope.incident.estRepairCost.value = null;
                }
            }
        });

        $scope.incidentLocation = function () {
            return $scope.cpPolicyExtension.locations.find(function (location) {
                return location.number === $scope.incident.location.value;
            });
        };

        $scope.buildingsInLocation = function () {
            return $scope.cpPolicyExtension.propertyRiskUnits.filter(function (ru) {
                return ru.locationNumber === $scope.incident.location.value;
            });
        };
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'LocaleService'];

export default fn;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/fnol/cp/directives/PropertyDetails/PropertyDetailsCtrl.js
// module id = 1539
// module chunks = 0